export const CLIENT_ACTIONS = {
  VIEW: 'VIEWED',
  APPROVE: 'APPROVED',
  REJECT: 'REJECTED',
  PROVIDE_FEEDBACK: 'FEEDBACK_PROVIDED',
  COMPLETE: 'COMPLETED',
} as const;

export type ClientAction = (typeof CLIENT_ACTIONS)[keyof typeof CLIENT_ACTIONS];

export const CLIENT_ACTION_MESSAGES: Record<ClientAction, string> = {
  [CLIENT_ACTIONS.VIEW]: 'Viewed',
  [CLIENT_ACTIONS.APPROVE]: 'Approved',
  [CLIENT_ACTIONS.REJECT]: 'Rejected',
  [CLIENT_ACTIONS.PROVIDE_FEEDBACK]: 'Provided feedback',
  [CLIENT_ACTIONS.COMPLETE]: 'Completed',
};
